import { PowerSourceTypeBase } from './base/power-source-type-base';

export class PowerSourceType extends PowerSourceTypeBase { }